import React from 'react';
import hoverManager from '../../../utils/HoverManager';
import { expandFontLineHeight, expandFontSizeList } from '../../../../actions/MenuActions';
import appParameters from '../../../utils/AppParameters';
import configuration from '../../../../constants/Configuration';
import storeManager from '../../../../store/StoreManager';
import mouseUtils from '../../../utils/MouseUtils';
import { FontMenu } from './subcomponents/FontMenu';
import { FontSizeView } from './subcomponents/FontSizeView';
import { FontLineHeightMenu } from './subcomponents/FontLineHeightMenu';
import { ColorPallete } from './subcomponents/ColorPallete';
import textEditorUtils from '../utils/TextEditorUtils';

const Button = React.createClass({
    getInitialState() {
        return {
            isOver: false,
            isButtonSelected: false
        };
    },
    onMouseIn() {
        switch (this.props.index) {
            // line 1
            case 0: { // A
                hoverManager.show(this.refs.button, 'fontColor', 'top');
                break;
            }

            case 1: { // B
                hoverManager.show(this.refs.button, 'bold', 'top');
                break;
            }
            case 2: { // I
                hoverManager.show(this.refs.button, 'italic', 'top');
                break;
            }
            case 3: { // U
                hoverManager.show(this.refs.button, 'underline', 'top');
                break;
            }

            case 4: { // Left align
                hoverManager.show(this.refs.button, 'leftAlign', 'top');
                break;
            }
            case 5: { // Center align
                hoverManager.show(this.refs.button, 'centerAlign', 'top');
                break;
            }
            case 6: { // Right align
                hoverManager.show(this.refs.button, 'rightAlign', 'left');
                break;
            }

            /*** line 2 ****/

            case 7: {
                hoverManager.show(this.refs.button, 'orderedList', 'top');
                break;
            }
            case 8: {
                hoverManager.show(this.refs.button, 'bulletList', 'top');
                break;
            }
            case 9: {
                hoverManager.show(this.refs.button, 'ident', 'top');
                break;
            }
            case 10: {
                hoverManager.show(this.refs.button, 'outdent', 'top');
                break;
            }

            case 11: {
                hoverManager.show(this.refs.button, 'superscript', 'top');
                break;
            }
            case 12: {
                hoverManager.show(this.refs.button, 'subscript', 'top');
                break;
            }


            case 13: {
                hoverManager.show(this.refs.button, 'lineHeight', 'left');
                break;
            }
        }

        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (e.target && e.target.className.length > 0 && e.target.className.indexOf('lineHeightButton') != -1)
            return;

        if (this.props.index === 0) {
            this.props.showColorPallete(!this.state.isButtonSelected);

            this.setState({
                isButtonSelected: !this.state.isButtonSelected
            })
        }

        textEditorUtils.executeAction(this.props.index);
        this.props.executeCommand(this.props.index);

        this.updateButtonFocus();
    },
    updateButtonFocus() {
        setTimeout(function() {
            this.refs.button.focus();
        }.bind(this), 100);
    },
    getLefPosition() {
        let leftPosition = 0;
        let buttonSize = this.props.buttonSize;

        switch (this.props.index) {
            // line 1
            case 0: { // A
                leftPosition = buttonSize * 0;
                break;
            }

            case 1: { // B
                leftPosition = buttonSize * 2;
                break;
            }
            case 2: { // I
                leftPosition = buttonSize * 3;
                break;
            }
            case 3: { // U
                leftPosition = buttonSize * 4;
                break;
            }

            case 4: { // Left align
                leftPosition = buttonSize * 6;
                break;
            }
            case 5: { // Center align
                leftPosition = buttonSize * 7;
                break;
            }
            case 6: { // Right align
                leftPosition = buttonSize * 8;
                break;
            }

            // line 2
            case 7: { // orderedList
                leftPosition = buttonSize * 0;
                break;
            }
            case 8: { // bulletList
                leftPosition = buttonSize * 1;
                break;
            }
            case 9: { // ident
                leftPosition = buttonSize * 2;
                break;
            }
            case 10: { // outdent
                leftPosition = buttonSize * 3;
                break;
            }

            case 11: { // superscript
                leftPosition = buttonSize * 5;
                break;
            }
            case 12: { // subscript
                leftPosition = buttonSize * 6;
                break;
            }


            case 13: { // lineHeight
                leftPosition = buttonSize * 8;
                break;
            }
        }

        return leftPosition;
    },
    isSelected() {
        let  value = false;

        switch(this.props.index) {
            // line 1
            case 0: { // A
                return this.state.isButtonSelected;
                break;
            }

            case 1: { // B
                value = textEditorUtils.isSelectedStyle('bold');
                break;
            }
            case 2: { // I
                value = textEditorUtils.isSelectedStyle('italic');
                break;
            }
            case 3: { // U
                value = textEditorUtils.isSelectedStyle('underline');
                break;
            }


            case 4: { // Left align
                value = textEditorUtils.isSelectedStyle('left');
                break;
            }
            case 5: { // Center align
                value = textEditorUtils.isSelectedStyle('center');
                break;
            }
            case 6: { // Right align
                value = textEditorUtils.isSelectedStyle('right');
                break;
            }

            // line 2
            case 7: { // orderedList
                value = textEditorUtils.isSelectedStyle('OL');
                break;
            }
            case 8: { // bulletList
                value = textEditorUtils.isSelectedStyle('UL');
                break;
            }
            case 9: { // ident
                value = false;
                break;
            }
            case 10: { // outdent
                value = false;
                break;
            }

            case 11: { // superscript
                value = textEditorUtils.isSelectedStyle('super');
                break;
            }
            case 12: { // subscript
                value = textEditorUtils.isSelectedStyle('sub');
                break;
            }

            case 13: { // lineHeight
                return false;
                break;
            }
        }

        return value;
    },
    getAriaLabel() {
        switch (this.props.index) {
            case 0: { // A
                return hoverManager.getText('fontColor');
            }
            case 1: { // B
                return hoverManager.getText('bold');
            }
            case 2: { // I
                return hoverManager.getText('italic');
            }
            case 3: { // U
                return hoverManager.getText('underline');
            }
            case 4: { // Left align
                return hoverManager.getText('leftAlign');
            }
            case 5: { // Center align
                return hoverManager.getText('centerAlign');
            }
            case 6: { // Right align
                return hoverManager.getText('rightAlign');
            }
            case 7: {
                return hoverManager.getText('orderedList');
            }
            case 8: {
                return hoverManager.getText('bulletList');
            }
            case 9: {
                return hoverManager.getText('ident');
            }
            case 10: {
                return hoverManager.getText('outdent');
            }
            case 11: {
                return hoverManager.getText('superscript');
            }
            case 12: {
                return hoverManager.getText('subscript');
            }
            case 13: {
                return hoverManager.getText('lineHeight');
            }
        }

        return '';
    },
    getIcon() {
        let host;

        if (configuration.LOAD_LOCAL === true)
            host = '';
        else
            host = appParameters.RESOURCES_LOCATION();

        switch(this.props.index) {
            // line 1
            case 0: { // A
                return host + 'assets/textEditor/fontColor';
            }

            case 1: { // B
                return host + 'assets/textEditor/bold';
            }
            case 2: { // I
                return host + 'assets/textEditor/italic';
            }
            case 3: { // U
                return host + 'assets/textEditor/underline';
            }

            case 4: { // Left align
                return host + 'assets/textEditor/left';
            }
            case 5: { // Center align
                return host + 'assets/textEditor/center';
            }
            case 6: { // Right align
                return host + 'assets/textEditor/right';
            }

            // line 2
            case 7: { // orderedList
                return host + 'assets/textEditor/listOrdered';
            }
            case 8: { // bulletList
                return host + 'assets/textEditor/listUnordered';
            }
            case 9: { // indent
                return host + 'assets/textEditor/indent';
            }
            case 10: { // outdent
                return host + 'assets/textEditor/outdent';
            }

            case 11: { // superscript
                return host + 'assets/textEditor/sup';
            }
            case 12: { // subscript
                return host + 'assets/textEditor/sub';
            }

            case 13: { // lineHeight
                return host + 'assets/textEditor/lineHeight';
            }
        }

        return '';
    },
    onFocusHandler() {
        if (document.activeElement.id.indexOf('subscriptButton') != -1)
            storeManager.getStore().dispatch(expandFontLineHeight(false));

        if (document.activeElement.id.indexOf('fontColorButton') != -1)
            storeManager.getStore().dispatch(expandFontSizeList(false));
    },
    render() {
        const buttonWidth = this.props.buttonSize;
        const buttonHeight = this.props.buttonSize;
        let gap = 2;
        let isSelected = this.isSelected();

        let buttonStyle = {
            position: 'absolute',
            top: this.props.top,
            width: buttonWidth,
            height: buttonHeight,
            left: this.getLefPosition(),
            cursor: 'pointer',
            background: '#f9f9f9',
            borderRadius: 4,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        let middleStyle = {
            position: 'absolute',
            top: gap,
            width: buttonWidth - 2*gap,
            height: buttonHeight - 2*gap,
            left: gap,
            cursor: 'pointer',
            borderRadius: 2,
            background: isSelected ? '#0078a3' : (this.state.isOver ? '#edefff' : '#f9f9f9')
        };

        let iconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: middleStyle.width,
            height: middleStyle.height,
            pointerEvents: 'none'
        };

        let buttonId;
        let colorBar;

        switch (true) {
            case (this.props.index === 0) : {
                buttonId = 'fontColorButton';
                break;
            }
            case (this.props.index === 12) : {
                buttonId = 'subscriptButton';
                break;
            }
            case (this.props.index === 13) : {
                buttonId = 'fontLineHeightMenu';
                break;
            }
        }

        if (this.props.index === 0) {
            iconStyle.width = 27;
            iconStyle.height = 27;
            iconStyle.top = -2;
            iconStyle.left = 1;

            let colorBarStyle = {
                position: 'absolute',
                width: buttonWidth - 2 * gap - 2 * gap - 2,
                height: 4,
                background: this.props.currentColor,
                left: gap,
                bottom: 2,
                borderRadius: 50,
                borderStyle: 'solid',
                borderWidth: 1,
                borderColor: '#c4c4c4'
            };

            colorBar = <span id="colorBar" style={colorBarStyle}></span>
        }

        let icon = this.getIcon();

        if (isSelected)
            icon = icon + '_white.svg';
        else
            icon = icon + '.svg';

        return (
            <button aria-label={this.getAriaLabel()} id={buttonId} ref='button' style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onFocus={this.onFocusHandler}>
                <span style={middleStyle}>
                    <img alt='' aria-hidden='true' style={iconStyle} src={icon} />
                    {colorBar}
                </span>
            </button>
        );
    }
});

export const EditTextArea = React.createClass({
    getInitialState() {
        return {
            show: false
        };
    },
    showColorPallete(value) {
        this.setState({
            show: value
        });

        this.props.checkFontColors(value);
    },
    getCurrentColor() {
        let color = textEditorUtils.getCommandValue('fontcolor');

        color = textEditorUtils.getCorrectColor(color);

        return color;
    },
    render() {
        const gridSize = this.props.gridSize;
        const lineElementTopPadding = this.props.lineElementTopPadding;
        const lineHeight = gridSize + lineElementTopPadding;
        let gap = this.props.gap;
        let width = this.props.width;
        let colorElementSize = width / 10;

        const menuStyle = {
            position: 'absolute',
            top: this.props.top,
            left: gap,
            width: width,
            height: this.props.height
        };

        const line1Style = { // font-selector and size
            position: 'absolute',
            top: 0,
            left: 0,
            width: width,
            height: lineHeight
        };

        const line2Style = { // font color, bold, italic, etc
            position: 'absolute',
            top: line1Style.top + line1Style.height,
            left: 0,
            width: width,
            height: lineHeight
        };

        let line3Style = { // alignment, identation, etc
            position: 'absolute',
            top: line2Style.top + line2Style.height,
            left: 0,
            width: width,
            height: lineHeight
        };

        let fontTitleStyle = {
            position: 'absolute',
            top: 3,
            left: 0,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#606060'
        };

        let sizeTitleStyle = {
            position: 'absolute',
            top: 3,
            left: line1Style.width - 3 * gridSize,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#606060'
        };

        let currentColor = this.getCurrentColor();
        let fontColorPallete;

        if (this.state.show) {
            line3Style.top = 2 * lineHeight + this.props.palleteColorHeight;

            fontColorPallete = <ColorPallete type={'changeFontColor'} currentColor={currentColor} top={2 * lineHeight} topGap={lineElementTopPadding} width={width} gridSize={colorElementSize} executeCommand={this.props.executeColorPickerCommand} contextTarget={this.props.contextTarget} forceUpdateTextEditor={this.props.forceUpdateTextEditor}/>
        }

        let lineHeightMenu;

        if (this.props.fontLineHeightIsExpanded)
            lineHeightMenu = <FontLineHeightMenu top={lineElementTopPadding + gridSize} contextTarget={this.props.contextTarget} executeCommand={this.props.executeCommand}/>;

        return (
            <div style={menuStyle}>
                <div style={line1Style}>
                    <div style={fontTitleStyle}>{hoverManager.getText('fontTitle')}</div>
                    <FontMenu width={5 * gridSize} top={lineElementTopPadding} buttonSize={gridSize} contextTarget={this.props.contextTarget} executeCommand={this.props.executeCommand} fontName={textEditorUtils.getCommandValue('fontname')}/>
                    <div style={sizeTitleStyle}>{hoverManager.getText('sizeTitle')}</div>
                    <FontSizeView refresh={Math.random()} buttonSize={gridSize} top={lineElementTopPadding} left={line1Style.width - 3 * gridSize} contextTarget={this.props.contextTarget} executeCommand={this.props.executeCommand}/>
                </div>

                <div style={line2Style}>
                    <Button index={0} currentColor={currentColor} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-amazon' holderWidth={this.props.width} showColorPallete={this.showColorPallete} executeCommand={this.props.executeCommand}/>

                    <Button index={1} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-bold' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={2} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-italic' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={3} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-underline' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>

                    <Button index={4} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-align-left' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={5} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-align-center' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={6} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-align-right' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                </div>

                {fontColorPallete}

                <div style={line3Style}>
                    <Button index={7} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-list-ol' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={8} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-list-ul' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={9} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-indent' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={10} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-outdent' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>

                    <Button index={11} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-superscript' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>
                    <Button index={12} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-subscript' holderWidth={this.props.width} executeCommand={this.props.executeCommand}/>

                    <Button index={13} top={lineElementTopPadding} buttonSize={gridSize} icon='fa fa-text-height' holderWidth={this.props.width} executeCommand={this.props.executeCommand} contextTarget={this.props.contextTarget}/>

                    {lineHeightMenu}
                </div>
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/EditTextArea.js
 **/